import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import queryString from 'query-string';
// import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import MenuRegisterButton from '../../components/atoms/MenuRegisterButton';
import StepBackButton from '../../components/atoms/StepBackButton';
import GochiChildFoodListTable from '../organisms/GochiChildFoodListTable';
import GochiChildFoodListAdd from '../organisms/GochiChildFoodListAdd';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getGochiChildFoodLists,
  getChildFoodGroups,
  getChildFoodShops
} from '../../actions/GochiChildFoodLists';
import { getAccounts } from '../../actions/Accounts';

const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 10px 0px 0px !important',
    width: '300px',
    zIndex: 3
  },
  textField150: {
    padding: '0px 10px 0px 0px !important',
    width: '200px',
    zIndex: 3
  },
  textFieldAlter: {
    padding: '0px 5px 0px 0px !important',
    width: '300px',
    zIndex: 3
  },
  textFieldAlter150: {
    padding: '0px 10px 0px 0px !important',
    width: '200px',
    zIndex: 3
  },
  textFieldTest: {
    padding: '0px 10px 0px 0px !important',
    width: '300px !important',
    paddingBottom: '50px'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      belongToChildGroups: state.accounts.belongToChildGroups,
      groups: state.groups.list,
      shops: state.shops.list
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiChildFoodLists,
          getAccounts,
          getChildFoodShops,
          getChildFoodGroups
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('openViewOrderCustom', 'updateOpenViewOrderCustom', false),
  withState('openViewOrderCustomList', 'updateOpenViewOrderCustomList', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('childFoodId', 'setChildFoodId', null),
  withState('shopId', 'setShopId', null),
  withState('groupId', 'setGroupId', null),
  withState('childFoodDescription', 'setChildFoodDescription', ''),
  withState('groupName', 'setGroupName', ''),
  withState('shopName', 'setShopName', ''),
  withState('menuName', 'setMenuName', ''),
  withState('targetGroupId', 'setTargetGroupId', props => {
    return queryString.parse(props.location.search).groupId || 0;
  }),
  withState('targetShopId', 'setTargetShopId', props => {
    return queryString.parse(props.location.search).shopId || 0;
  }),
  withState('childFoodName', 'setChildFoodName', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const searchKey = {
        groupId: props.targetGroupId ? props.targetGroupId : '',
        shopName: props.shopName ? props.shopName : '',
        childFoodName: props.childFoodName,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getGochiChildFoodLists(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);

        const searchShopId = queryString.parse(this.props.location.search)
          .shopId;
        this.props.setShopId(Number(searchShopId));
        const searchGroupId = queryString.parse(this.props.location.search)
          .groupId;
        this.props.setGroupId(Number(searchGroupId));
        this.props.actions.getChildFoodGroups();
        this.props.actions.getChildFoodShops();
        if (
          data.payload.role === 'SHOP' &&
          (data.payload.belongToChildGroups !== 'undefined' &&
            data.payload.belongToChildGroups.length > 0)
        ) {
          this.props.actions
            .getGochiChildFoodLists({
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(menuData => this.props.checkSession(menuData));
          this.props.updateOpenTable(true);
        } else if (searchShopId && searchGroupId) {
          await this.props.actions
            .getGochiChildFoodLists({
              shopId: searchShopId,
              groupId: searchGroupId,
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(async menuData => {
              this.props.checkSession(menuData);
              if (menuData.payload.menus.length) {
                this.props.setShopName(menuData.payload.menus[0].shopName);
                this.props.setGroupName(menuData.payload.menus[0].groupName);
              } else {
                await this.props.actions
                  .getChildFoodShops({ shopId: searchShopId })
                  .then(shopData => {
                    this.props.checkSession(shopData);
                    this.props.setShopName(shopData.payload.groups[0].shopName);
                  });
                await this.props.actions
                  .getChildFoodGroups({ groupId: searchGroupId })
                  .then(groupData => {
                    this.props.checkSession(groupData);
                    this.props.setGroupName(
                      groupData.payload.groups[0].groupName
                    );
                  });
              }
            });
          this.props.updateOpenTable(true);
        }
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleRedirect,
    handleChangePage,
    account,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    openAdd,
    updateOpenAdd,
    openAddConfirm,
    updateOpenAddConfirm,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    shopId,
    setShopId,
    groupId,
    setGroupId,
    setChildFoodDescription,
    // groupName,
    // setGroupName,
    targetGroupId,
    setTargetGroupId,
    // targetShopId,
    // setTargetShopId,
    shopName,
    setShopName,
    childFoodName,
    setChildFoodName,
    resultMessage,
    setResultMessage,
    page,
    groups
    // shops,
  }) => {
    const isCreateChildFoodShop =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      (account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0);
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const roles = {
      isCreateChildFoodShop,
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }
    const searchKey = {
      groupId: targetGroupId > 0 ? targetGroupId : null,
      shopName,
      childFoodName,
      page,
      limit: limitNum
    };

    const getGroupOptions = () => {
      const groupOptions = [];
      if (isSecretariat) {
        groups
          .filter(item => item.groupType.toUpperCase() === 'OTHERS')
          .forEach(group => {
            groupOptions.push({
              label: group.groupName,
              value: String(group.groupId)
            });
          });
      }
      if (isCreateChildFoodShop) {
        groups
          .filter(item => account.belongToChildGroups.includes(item.groupId))
          .forEach(group => {
            groupOptions.push({
              label: group.groupName,
              value: String(group.groupId)
            });
          });
      }

      return groupOptions;
    };

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
      // updateLoading(true);
      // updateOpenProgress(true);
      // await actions
      //   .getGochiMenus(searchKey)
      //   .then(data => {
      //     checkSession(data);
      //     updateOpenProgress(false);
      //     updateLoading(false);
      //     handleChangePage(null, 0);
      //     updateOpenTable(true);
      //   })
      //   .catch(() => {
      //     updateOpenProgress(false);
      //     updateLoading(false);
      //   });
    };

    const addAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const shopData = await actions
        .getChildFoodShops()
        .then(data => checkSession(data));
      if (shopData.type === 'GET_SHOPS_SUCCESS') {
        if (!shopId) {
          const initialShopId =
            isCreateChildFoodShop && shopData.payload.list[0] !== undefined
              ? shopData.payload.list[0].shopId
              : 0;
          setShopId(initialShopId);
        }
        updateOpenProgress(false);
        updateLoading(false);
        updateOpenAdd(true);
      } else {
        updateOpenProgress(false);
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const backAction = () => handleRedirect('/release_step');
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            こども食堂メニュー
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              {roles.isSecretariat && (
                <TextField
                  label="店舗名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopName}
                  onChange={e => {
                    setShopName(e.target.value);
                  }}
                />
              )}
              {roles.isCreateChildFoodShop && (
                <TextField
                  required
                  label="店舗名"
                  defaultValue={account.shopName}
                  // value={fixedShopName}
                  className={classes.textFieldTest}
                  margin="normal"
                  InputProps={{
                    readOnly: true
                  }}
                  // variant="filled"
                />
              )}
              {/* <br /> */}
              {(roles.isSecretariat || roles.isCreateChildFoodShop) && (
                <TextField
                  label="メニュー名"
                  placeholder="部分一致"
                  type="search"
                  className={[classes.textField]}
                  margin="normal"
                  value={childFoodName}
                  onChange={e => {
                    setChildFoodName(e.target.value);
                  }}
                />
              )}
            </div>
            <div className="selectShop">
              {(roles.isSecretariat || roles.isCreateChildFoodShop) && (
                <ReactSelectMaterialUi
                  required
                  label="グループ名"
                  className={classes.textFieldAlter}
                  defaultValue={String(targetGroupId)}
                  options={getGroupOptions()}
                  margin="normal"
                  onChange={v => {
                    setTargetGroupId(Number(v));
                  }}
                  SelectProps={{
                    isClearable: true,
                    msgNoOptionsMatchFilter:
                      '名前が部分一致するグループがありません'
                  }}
                />
              )}
            </div>
            {(roles.isSecretariat || roles.isCreateChildFoodShop) && (
              <div className={classes.buttonGroupLeft}>
                <SearchButton onClickAction={searchAction} />
              </div>
            )}
            {(roles.isSecretariat || roles.isCreateChildFoodShop) && (
              <div className={classes.buttonGroupRight}>
                <MenuRegisterButton onClickAction={addAction} />
                {/* <MenuViewOrderEditButton onClickAction={viewOrderCustomAction} />
              {(roles.isSecretariat || roles.isDeveloper) && (
                <CsvDownloadButton onClickAction={csvDownloadAction} />
              )} */}
              </div>
            )}
          </div>
          {(roles.isSecretariat || roles.isCreateChildFoodShop) &&
            openTable && (
              <GochiChildFoodListTable
                searchKey={searchKey}
                roles={roles}
                progress={progress}
                page={page}
                handleChangePage={handleChangePage}
                selectedPage={page}
              />
            )}
          {isShop && !isReleased && (
            <div>
              <StepBackButton onClickAction={backAction} />
            </div>
          )}

          <div>
            <Modal open={openAdd}>
              <GochiChildFoodListAdd
                openAddConfirm={openAddConfirm}
                updateOpenAdd={updateOpenAdd}
                updateOpenAddConfirm={updateOpenAddConfirm}
                searchKey={searchKey}
                shopId={shopId}
                setShopId={setShopId}
                groupId={groupId}
                setGroupId={setGroupId}
                setChildFoodDescription={setChildFoodDescription}
              />
            </Modal>
          </div>
          <ProgressDialog openProgress={openProgress} loading={loading} />
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
